import { createFileRoute } from '@tanstack/react-router'
import { ExamDeletePage } from '@/features/exams/delete'

export const Route = createFileRoute('/exams_/$examId/delete')({
  component: RouteComponent,
})

function RouteComponent() {
  const { examId } = Route.useParams()
  return <ExamDeletePage examId={examId} />
}
